import React from "react";
import { Box, Typography, Container, Grid, Chip } from "@mui/material";
import EventCard from "../../components/cards/EventCard";
import eventsData from "../../data/events";

const Events = () => {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8f9fa" }}>
      {/* HERO SECTION */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #e86c2c, #d65b1f)",
          color: "white",
          pt: { xs: 18, md: 20 }, // Increased padding for a more dramatic entrance
          pb: { xs: 8, md: 10 },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Container maxWidth="lg">
          {/* Tag / Badge */}
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              bgcolor: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(4px)",
              px: 2,
              py: 0.8,
              borderRadius: "50px",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              mb: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "11px", sm: "13px" },
                fontWeight: "600",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              📅 Upcoming Events
            </Typography>
          </Box>

          {/* Title */}
          <Typography
            variant="h1"
            sx={{
              fontWeight: "800",
              fontSize: { xs: "32px", sm: "48px", md: "60px" },
              lineHeight: 1.1,
              maxWidth: "800px",
              mb: 3,
              mx: { xs: "auto", md: "0" },
            }}
          >
            Events & <span style={{ opacity: 0.8 }}>Insights</span>
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "18px" },
              maxWidth: "650px",
              opacity: 0.9,
              lineHeight: 1.6,
              mx: { xs: "auto", md: "0" },
            }}
          >
            Explore our curated events bringing together industry leaders and
            business strategists for actionable intelligence.
          </Typography>
        </Container>
      </Box>

      {/* LISTING SECTION */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        {/* Results Metadata */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 5,
            borderBottom: "1px solid #e0e0e0",
            pb: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "600",
              color: "text.secondary",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Showing {eventsData.length} events
          </Typography>

          <Typography variant="caption" sx={{ color: "text.disabled" }}>
            Sorted by: Latest
          </Typography>
        </Box>

        {/* Grid Layout */}
        <Grid container spacing={4}>
          {eventsData.map((event) => (
            <Grid item xs={12} sm={6} md={4} key={event.id}>
              <Box
                sx={{
                  height: "100%",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                <EventCard event={event} />
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Optional Empty State */}
        {eventsData.length === 0 && (
          <Box sx={{ textAlign: "center", py: 10 }}>
            <Typography variant="h6" color="text.secondary">
              No events found at the moment. Check back soon!
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Events;
